<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chap_section">Acknowledgements</h2>
<p class="noindent"><span class="dropcap">I</span> would like to take this opportunity to thank the numerous individuals who have given their time and lent their expertise to the production of this book. Firstly I must acknowledge the assistance of Doctor Jacqueline Reiter without whom this work would never have seen the light of day. I would also like to recognize the contribution of John Harcourt who worked so hard to translate my rough sketches into splendid maps and Romain Cames who translated Milyutin’s history of the campaign from the original Russian. Finally I give thanks to my partner Tracy and my parents who helped to ensure the text was readable and all my friends and colleagues who have endured my obsession with this campaign over the last few years.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Acknowledgements.vue?5f091c4e